<h2 mat-dialog-title>{{ title }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="student-form">
    <div class="row-fields" *ngIf="!isCreate()">
      <mat-form-field appearance="outline">
        <mat-label>Roll number</mat-label>
        <input matInput formControlName="rollNumber" readonly />
      </mat-form-field>
    </div>

    <div class="row-fields">
      <mat-form-field appearance="outline">
        <mat-label>First name</mat-label>
        <input matInput formControlName="firstName" autocomplete="given-name" />
        <mat-error *ngIf="form.get('firstName')?.hasError('required')">Required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Last name</mat-label>
        <input matInput formControlName="lastName" autocomplete="family-name" />
        <mat-error *ngIf="form.get('lastName')?.hasError('required')">Required</mat-error>
      </mat-form-field>
    </div>

    <div class="row-fields">
      <mat-form-field appearance="outline">
        <mat-label>Date of birth</mat-label>
        <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth" />
        <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
        <mat-datepicker #dobPicker></mat-datepicker>
        <mat-hint>Required for new admissions</mat-hint>
        <mat-error *ngIf="form.get('dateOfBirth')?.hasError('required')">Date of birth is required</mat-error>
      </mat-form-field>
    </div>

    <div class="row-fields">
      <mat-form-field appearance="outline">
        <mat-label>Class</mat-label>
        <mat-select formControlName="className" required>
          <mat-option *ngFor="let c of classOptions" [value]="c">{{ c }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('className')?.hasError('required')">Class is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Gender</mat-label>
        <mat-select formControlName="gender" required>
          <mat-option *ngFor="let g of genderOptions" [value]="g.value">{{ g.label }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('gender')?.hasError('required')">Gender is required</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Blood group</mat-label>
        <mat-select formControlName="bloodGroup">
          <mat-option value="">None</mat-option>
          <mat-option *ngFor="let b of bloodGroupOptions" [value]="b">{{ b }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="row-fields">
      <mat-form-field appearance="outline">
        <mat-label>Father name</mat-label>
        <input matInput formControlName="fatherName" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Mother name</mat-label>
        <input matInput formControlName="motherName" />
      </mat-form-field>
    </div>
    <div class="row-fields">
      <mat-form-field appearance="outline">
        <mat-label>Mobile</mat-label>
        <input matInput formControlName="mobileNumber" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" placeholder="Optional contact email (login is provisioned separately)" />
        <mat-error *ngIf="form.get('email')?.hasError('email')">Invalid email</mat-error>
      </mat-form-field>
    </div>

    <div formGroupName="addressDto" class="address-block">
      <h3 class="section-title">Address</h3>
      <div class="row-fields">
        <mat-form-field appearance="outline">
          <mat-label>Door / street</mat-label>
          <input matInput formControlName="doorNo" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>City</mat-label>
          <input matInput formControlName="city" />
        </mat-form-field>
      </div>
      <div class="row-fields">
        <mat-form-field appearance="outline">
          <mat-label>State</mat-label>
          <input matInput formControlName="state" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Country</mat-label>
          <input matInput formControlName="country" />
        </mat-form-field>
      </div>
      <mat-form-field appearance="outline" class="full">
        <mat-label>Pincode</mat-label>
        <input matInput formControlName="pincode" />
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">{{ isView() ? 'Close' : 'Cancel' }}</button>
  <button *ngIf="!isView()" mat-flat-button color="primary" type="button" (click)="submit()" [disabled]="form.invalid">
    Submit
  </button>
</mat-dialog-actions>
